import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { ITableModelDefault } from 'shared/ui/TableNew'
import type { PerformanceAnalyticsKeys } from 'entities/Analytics/api/types'
import type { AnalyticsComparisonEntity } from 'pages/analytics/ui'

export interface IPerformanceComparisonData extends ITableModelDefault {
  id: string | number
  name: string
  metrics: Record<PerformanceAnalyticsKeys, number>
  breakdownEntity?: AnalyticsComparisonEntity
}

export class RowPerformanceComparison extends RowBase<IPerformanceComparisonData> {
  constructor(data: IPerformanceComparisonData) {
    super(data)

    makeObservableRowBase(this, {
      fields: computed,
    })
  }

  get fields() {
    return {
      name: this.origin.name,
      avg_time_to_first_response: this.origin.metrics.avg_time_to_first_response,
      avg_time_to_response: this.origin.metrics.avg_time_to_response,
      avg_time_to_close: this.origin.metrics.avg_time_to_close,
      breakdownEntity: this.origin.breakdownEntity,
    }
  }
}
